import { z } from "zod";
import { AgencyIdSchema } from "../primitives/ids.js";
import { ClaimIdSchema } from "./agency-unlock.js";
import { ReportIdSchema } from "../primitives/ids.js";
import { TraceContextSchema } from "./trace.js";
import { FixKitIdSchema } from "./fix-kit.js";
/** fix-kit-job-payload.v1.0 — BullMQ worker job for Fix Kit artifact composition. */
export const FixKitJobPayloadV1Schema = z
    .object({
    schemaVersion: z.literal("fix-kit-job-payload.v1.0"),
    jobKind: z.literal("COMPOSE_FIX_KIT"),
    fixKitId: FixKitIdSchema,
    claimId: ClaimIdSchema,
    agencyId: AgencyIdSchema,
    publicReportRef: ReportIdSchema,
    generatedByUserId: z.string().min(1),
    trace: TraceContextSchema,
})
    .strict();
export const FIX_KIT_QUEUE_NAME = "tier0-fix-kit";
export function fixKitEnqueueJobId(claimId) {
    return `enr:fixkit:${claimId}`;
}
//# sourceMappingURL=fix-kit-job-payload.js.map